import React from 'react';
import { Table } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
  LastTransactionsRecord,
  LastTransactionsTableEntry,
} from 'utils/apiClient/services/reports/types';

const BoldText = styled.span`
  font-weight: 500;
`;

export interface Props {
  currency: string;
  loading?: boolean;
  transactions?: Array<LastTransactionsTableEntry>;
}

const LastTransactionsTable: React.FC<Props> = ({
  currency,
  loading,
  transactions,
}) => {
  const intl = useIntl();
  return (
    <Table<LastTransactionsTableEntry>
      size="small"
      rowKey={(t) => `${t.id}-${t.income}`}
      pagination={false}
      loading={loading}
      dataSource={transactions}
      css={`
        .ant-table,
        .ant-table-thead > tr > th {
          color: rgba(0, 0, 0, 0.65);
        }
      `}
      scroll={{ x: true }}
    >
      <Table.Column<LastTransactionsRecord>
        key="date"
        title={intl.formatMessage({ defaultMessage: 'Date' })}
        dataIndex="date"
      />
      <Table.Column<LastTransactionsRecord>
        key="invoice_number"
        title={intl.formatMessage({ defaultMessage: 'Invoice nr.' })}
        render={(item) => <BoldText>{item.invoice_number}</BoldText>}
      />
      <Table.Column<LastTransactionsRecord>
        key="customer"
        title={intl.formatMessage({ defaultMessage: 'Buyer' })}
        dataIndex="customer"
      />
      <Table.Column<LastTransactionsRecord>
        key="employee"
        title={intl.formatMessage({ defaultMessage: 'Employee' })}
        dataIndex="employee"
      />
      <Table.Column<LastTransactionsRecord>
        key="invoice_total"
        title={intl.formatMessage({ defaultMessage: 'Invoice total' })}
        render={(item) => (
          <BoldText>
            {intl.formatNumber(item.income, { style: 'currency', currency })}
          </BoldText>
        )}
      />
      <Table.Column<LastTransactionsRecord>
        key="payment_method"
        title={intl.formatMessage({ defaultMessage: 'Payment method' })}
        render={(item) =>
          item.payment_method && <FormattedMessage {...item.payment_method} />
        }
      />
    </Table>
  );
};

export default LastTransactionsTable;
